import script from "./AdminUserView.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminUserView.vue?vue&type=script&setup=true&lang=js"

import "./AdminUserView.vue?vue&type=style&index=0&id=1d80e024&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d80e024"]])

export default __exports__